module.exports = __webpack_public_path__ + "static/img/LACQUERED-PVC-PRESTON.363d21f.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LACQUERED-PVC-PRESTON.png
// module id = ljQY
// module chunks = 0